import axios from "axios";

export default abstract class BaseAbstractService {
    /**
     * getBaseUri
     * Base method to retrieve api base url (abstract)
     *
     * @return string
     */
    protected static getBaseUri(): string {
        return process.env.VUE_APP_API_URL || '';
    }

    /**
     * get
     * Generic method to get information from API.
     * 
     * @param path 
     * @param query 
     * @param decode 
     */
    protected static async get(path: string, query?: any) {
        let client = this.buildClient();

        let response: any;

        try {
            response = await client.get(
                path,
                { params: query },
            );
            if (response.status >= 200 && response.status < 300) {
                if (response.status == 204) return null;
                return response.data;
            }
        } catch (error) {
            try {
                throw new Error('erro');
            } catch (e) {
                throw new Error('erro');
            }
        }
    }

    /**
     * post
     * Generic method to post information on API.
     * 
     * @param path 
     * @param query 
     * @param decode 
     */
    protected static async post(path: string, query?: any) {
        let client = this.buildClient();

        let response: any;

        try {
            response = await client.post(
                path,
                query,
            );
            if (response.status >= 200 && response.status < 300) {
                return response.data;
            }
        } catch (error) {
            // try {
                throw error.response.status;
                // console.error(error);
            // } catch (error) {
            //     console.error(error);
            // }
        }
    }

    protected static async put(path: string, query?: any) {
        let client = this.buildClient();

        let response: any;

        try {
            response = await client.put(
                path,
                query,
            );
            if (response.status >= 200 && response.status < 300) {
                return response.data;
            }
        } catch (error) {
            // try {
                console.log(this.getResponseMessage(error.response));
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response);
                throw error.response.status;
                // console.error(error);
            // } catch (error) {
            //     console.error(error);
            // }
        }
    }

    /**
     * buildClient
     * Base method to create a axios instance
     *
     * @return Axios
     */
    protected static buildClient() {
        let _axios = axios.create({
            baseURL: this.getBaseUri(),
            headers: {
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            withCredentials: false,
        });

        _axios.interceptors.request.use(
            function (config) {
                // Do something before request is sent
                return config;
            },
            function (error) {
                // Do something with request error
                return Promise.reject(error);
            }
        );

        // Add a response interceptor
        _axios.interceptors.response.use(
            function (response) {
                // Do something with response data
                return response;
            },
            function (error) {
                // Do something with response error
                return Promise.reject(error);
            }
        );

        return _axios;
    }

    /**
     * getResponseMessage
     * Resgata mensagem de erro
     * 
     * @param response 
     */
    protected static getResponseMessage(response: any) {
        let message = '';
        if (response.data.code == 410) {
            try {
                message = JSON.parse(response.data.api_message).message;
            } catch (e) {
                message = response.data.message;
            }
        } else {
            try {
                message = JSON.parse(response.data.message).message;
            } catch (e) {
                message = response.data.message;
            }
        }
        return message;
    }

}
